import gql from 'graphql-tag';

import credentialOAuthOneDriveFragment from './credentialOAuthOneDriveFragment';

export const credentialOAuthFragment = gql`
  fragment credentialOAuthFragment on CredentialOAuth {
    dokkioClass
    id
    accountID
    credentialOAuthType
    email
    remoteID
    remoteTeamID
    remoteTeamName
    scopes

    credentialOAuthOneDrive {
      ...credentialOAuthOneDriveFragment
    }
  }

  ${credentialOAuthOneDriveFragment}
`;
export default credentialOAuthFragment;
